import { QueryClient } from '@tanstack/query-core';

import { CACHE_TIME, STALE_TIME } from './constants';
import { logError } from './logger';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME,
      gcTime: CACHE_TIME,
      refetchOnWindowFocus: false,
      retryOnMount: false,
      throwOnError: (error, query) => {
        // @todo: this re-logs errors on every render, we should improve this
        logError('queryClient', `Error running query ${query.queryKey.join(',')}`, { error });
        return false;
      },
    },
    mutations: {
      throwOnError: (error) => {
        logError('queryClient', 'Error running mutation', { error });
        return false;
      },
    },
  },
});
